import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class OperationPerformance extends Model {
  @Expose() salesRevenue: number;
  @Expose() transportationCost: number;
  @Expose() profitMargin: number;
  @Expose() margin: number;
  @Expose() breakevenAmount: number;
  @Expose() breakevenCount: number;
  @Expose() losesAmount: number;
  @Expose() losesCount: number;
}
